import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouterContext } from 'contexts/router-context';
import { useGlobalContext } from 'contexts/global-context';
import useSidePaddingsOnHorizontalScroll from 'hooks/useSidePaddingsOnHorizontalScroll';
import Game from 'components/game';
import { Route, TGame } from 'types';
import './styles.scss';

interface IGameLikeThis {
  game: TGame;
}

const GameLikeThis: React.FC<IGameLikeThis> = ({ game }) => {
  const { games } = useGlobalContext();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  const { currentRoute, history } = useRouterContext();

  useSidePaddingsOnHorizontalScroll(ref);

  // Filter available games only once in order to get rid of this section's jerking on game page change.
  const gamesLikeThis = useMemo(() => {
    const alreadyOpenedGameIds = [currentRoute, ...history]
      .map((route) => route.name === Route.game ? route.param : null)
      .filter(Boolean);

    return games.filter(({ id }) => game.gamesLikeThis.includes(id) && !alreadyOpenedGameIds.includes(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game]);

  if (!gamesLikeThis.length) {
    return null;
  }

  return (
    <div className="game-like-this-container">
      <p className="p-side">{t('moreGamesLikeThis')}</p>
      <div className="flex scrollable-gutters overflow-x-scroll overflow-y-hidden no-scroll" ref={ref}>
        {gamesLikeThis.map((game: TGame) => (
          <Game key={game.id} game={game} />
        ))}
      </div>
    </div>
  );
};

export default GameLikeThis;
